import React, {memo} from "react";
import {Modal, ModalHeader, ModalBody} from "reactstrap";
import PropTypes from "prop-types";
import SimForm from "../Forms/SimForm";
// import {submitFormSim} from "../../helpers/Controllers";
// import {requestSims} from "../../redux/Actions/sims.actions";
import {getSimModalData} from "../../redux/Selectors/sim.selector";
import {useSelector} from "react-redux";
import Loader from "../Loader";

const AddSim = (props) => {
  // const dispatch = useDispatch();
  const {open, onClose} = props;
  const simData = useSelector(getSimModalData);

  // const onSubmit = (formDetails) => {
  //   submitFormSim(formDetails, (err, res) => {
  //     if (res) {
  //       onClose();
  //       dispatch(requestSims());
  //     }
  //   });
  // };

  return (
    <>
      <Modal unmountOnClose={true} isOpen={open} backdrop={"static"} size={"lg"}>
        <Loader />
        <ModalHeader>{simData?.id ? "Edit Sim" : "Add Sim"}</ModalHeader>
        <ModalBody>
          <div className="pl-lg-4">
            <SimForm onClose={onClose} />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

function areEqual(prevProps, nextProps) {
  return prevProps.open === nextProps.open;
}

AddSim.propTypes = {
  open: PropTypes.bool,
};
export default memo(AddSim, areEqual);
